import { getAccountCampaignSummary } from "../types/account_campaign_summary_types";

export const getAccountCampaignSummaryRequest = (payload) => ({
  type: getAccountCampaignSummary.GET_ACCOUNT_CAMPAIGN_SUMMARY_REQUEST,
  payload
});
export const getAccountCampaignSummarySuccess = (payload) => ({
  type: getAccountCampaignSummary.GET_ACCOUNT_CAMPAIGN_SUMMARY_SUCCESS,
  payload
});
export const getAccountCampaignSummaryFailure = (payload) => ({
  type: getAccountCampaignSummary.GET_ACCOUNT_CAMPAIGN_SUMMARY_FAILURE,
  payload
});